module.exports = __webpack_public_path__ + "img/Bumper-icon-selected.7451e088.png";